// Русский язык
export default {
	tabs: ["Вывод", "История"],
	History: {
		tabs: ["Рассмотрение", "Успех", "Отклонено"]
	},
	Withdraw: {
		label: ["Номер счета", "Номер ордера", "Адрес", "Сумма", "Комиссия", "Создан при", "Статус", "Причина"]
	},
	AccountAmount: "Сумма на счете",
	tips: "Вы получите свой вывод в течение часа",
	form: {
		label: ["Сумма вывода", "Пароль транзакции"],
		ALL: "ВСЕ",
		Withdraw: "Oтправить"
	},
	WithdrawAccount: "Вывести аккаунт",
	noAccountsTips: "Пожалуйста, добавьте способы оплаты",
	tradingKind: [
		"Кэшбэк",
		"Списание",
		"Пополнение",
		"Вывод в процессе",
		"Разморозка вывода",
		"Вывод",
		"Задание",
		"Возврат основного капитала",
		"Возврат комиссии",
		"Возврат комиссии подчинённых",
		"Отметка входа",
		"Комиссия за обработку",
		"Депозит",
		"Награда",
		"Базовая зарплата",
		"Денежная помощь",
		"Бонус за регистрацию",
		"Товарные дивиденды",
		"Бонус за задание",
		"Другое",
		"",
		"Рабочий бонус",
		"Награды за повышение",
		"Субсидия",
		"Ожидает проверки",
		"Кампания",
		"Обмен баллов",
		"Награды за вход",
		"Награды за работу",
		"Транзакция кредитного рейтинга"
	]
};
